import { default as gql } from 'graphql-tag';

export const popularTemplatesQuery = gql`
  query PopularTemplates(
    $roleCanonicalId: String
    $personalizeBy: SuggestionPersonalization!
    $limit: Int
  ) {
    suggestedZapTemplates(
      roleCanonicalId: $roleCanonicalId
      personalizeBy: $personalizeBy
      limit: $limit
    ) {
      edges {
        zapTemplate {
          title
          url
          services {
            image
            name
          }
        }
      }
    }
  }
`;
